import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/DatePicker.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// suppress specific deprecation message in dev
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args: any[]) => {
    if (
      args.length > 0 &&
      typeof args[0] === 'string' &&
      args[0].includes('findDOMNode is deprecated')
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

root.render(<App />);
